import React from 'react';
import { useThemeContext } from '../contexts/ThemeContext';
import './Toolbar.css';

function Toolbar({ activeView, onViewChange, onAboutClick, onToggleSidebar, sidebarOpen, onMobileBack, onMobileForward, canGoBack, canGoForward }) {
  const { theme, toggleTheme } = useThemeContext();
  const views = [
    { id: 'tree', icon: '≡', label: 'Files' },
    { id: 'search', icon: '⌕', label: 'Search' },
    { id: 'tags', icon: '#', label: 'Tags' }
  ];

  return (
    <div className="toolbar">
      <div className="toolbar-top">
        <button
          className={`toolbar-button hamburger-button ${sidebarOpen ? 'active' : ''}`}
          onClick={onToggleSidebar}
          title="Toggle Menu"
          aria-label="Toggle Menu"
        >
          <span className="toolbar-icon">☰</span>
        </button>

        {/* Back button - mobile only */}
        <button
          className={`toolbar-button mobile-nav-button ${!canGoBack ? 'disabled' : ''}`}
          onClick={onMobileBack}
          disabled={!canGoBack}
          title="Back"
          aria-label="Back"
        >
          <span className="toolbar-icon">←</span>
        </button>

        {/* Forward button - mobile only */}
        <button
          className={`toolbar-button mobile-nav-button ${!canGoForward ? 'disabled' : ''}`}
          onClick={onMobileForward}
          disabled={!canGoForward}
          title="Forward"
          aria-label="Forward"
        >
          <span className="toolbar-icon">→</span>
        </button>

        {views.map(view => (
          <button
            key={view.id}
            className={`toolbar-button view-button ${activeView === view.id ? 'active' : ''}`}
            onClick={() => {
              onViewChange(view.id);
              if (window.innerWidth <= 768) {
                onToggleSidebar();
              }
            }}
            title={view.label}
            aria-label={view.label}
          >
            <span className="toolbar-icon">{view.icon}</span>
          </button>
        ))}
      </div>

      <div className="toolbar-bottom">
        <button
          className="toolbar-button"
          onClick={onAboutClick}
          title="About"
          aria-label="About"
        >
          <span className="toolbar-icon">ℹ</span>
        </button>

        <button
          className="toolbar-button"
          onClick={toggleTheme}
          title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
          aria-label="Toggle theme"
        >
          <span className="toolbar-icon">{theme === 'dark' ? '☀' : '☾'}</span>
        </button>
      </div>
    </div>
  );
}

export default Toolbar;
